var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_2025",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 36.8C16.1998 36.8 15.8665 36.6667 15.5998 36.4C15.3331 36.1334 15.1998 35.8 15.1998 35.4V32H20.5998V24.9C19.2998 25.2667 17.9415 25.2917 16.5248 24.975C15.1081 24.6584 13.9665 24.0667 13.0998 23.2V20.2H10.0998L4.7998 14.9C5.93314 14 7.18314 13.3084 8.5498 12.825C9.91647 12.3417 11.3331 12.1 12.7998 12.1C14.1998 12.1 15.5581 12.3167 16.8748 12.75C18.1915 13.1834 19.4331 13.85 20.5998 14.75V10.8H39.3998V33.4C39.3998 34.3667 39.0748 35.175 38.4248 35.825C37.7748 36.475 36.9665 36.8 35.9998 36.8H16.5998ZM21.9998 32H33.9998V33.4C33.9998 33.9667 34.1915 34.4417 34.5748 34.825C34.9581 35.2084 35.4331 35.4 35.9998 35.4C36.5665 35.4 37.0415 35.2084 37.4248 34.825C37.8081 34.4417 37.9998 33.9667 37.9998 33.4V12.2H21.9998V16L32.6998 26.7V27.7H31.6998L25.4998 21.5L24.1498 22.85C23.7831 23.2167 23.4331 23.5167 23.0998 23.75C22.7665 23.9834 22.3998 24.2 21.9998 24.4V32ZM10.6998 18.8H14.4998V22.6C15.2665 23.0667 15.9665 23.3834 16.5998 23.55C17.2331 23.7167 17.8331 23.8 18.3998 23.8C19.3665 23.8 20.2415 23.6334 21.0248 23.3C21.8081 22.9667 22.5331 22.4667 23.1998 21.8L24.4998 20.5L20.7998 16.8C19.6998 15.7 18.4665 14.875 17.0998 14.325C15.7331 13.775 14.2998 13.5 12.7998 13.5C11.7331 13.5 10.6915 13.65 9.67481 13.95C8.65814 14.25 7.76647 14.6334 6.9998 15.1L10.6998 18.8Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryEdu);
export default __webpack_public_path__ + "static/media/history_edu.cf18eb56fe30ea2c8e13d703d29a46b6.svg";
export { ForwardRef as ReactComponent };